import React from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import { FcGoogle } from "react-icons/fc";
import {user_google_login} from "../api/Auth"
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

const GoogleAuth = () => {
    const navigate = useNavigate();

    const login = useGoogleLogin({
        onSuccess: async (response) => {
            console.log("Google Response:", response);

            // Call the global function to handle API request
            const result = await user_google_login(response.access_token);

            if (result?.token && result?.status) {
                // Store token and user data
                localStorage.setItem("token", result.token);
                localStorage.setItem("user", JSON.stringify(result.user));

                // Navigate to Home Page
                navigate("/home");
            } else {
                toast.error(result?.msg || "Google login failed.");
            }
        },
        onError: () => {
            console.log('Login Failed');
        },
    });

    return (
        <>
        {/* <-------- ToastContainer ------------> */}
        <ToastContainer style={{ marginTop: "120px" }} />
        <button
            onClick={() => login()}
            className="flex items-center justify-center w-full px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-100"
            >
            <FcGoogle className="w-6 h-6 mr-2" />
            <span>Sign in with Google</span>
        </button>
            </>
    );
};

export default GoogleAuth;
